import { Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useContext } from 'react';
import { EWContext } from "../../context/EWContext";
import './WarningMessage.css';

function WarningMessage(props) {
    const [accountState] = useContext(
        EWContext
    );

    const {
        conditionSpecificBehaviors
    } = accountState;

    return (
        <Grid container className='unitValue'>
            {
                (conditionSpecificBehaviors?.cr_isRequired_unit_warning && props.unitLength > 0) &&
                <Alert severity="warning">
                    {conditionSpecificBehaviors?.cr_unit_warning_message}
                </Alert>
            }
        </Grid>
    )
}
export default WarningMessage
